/*
alert-box.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('alertBox',[
    'angular',
    'sharedConstants'
], function () {

    var dependencies = [
        'Services.SharedConstants'
    ];

    //Module Definition
    angular.module('Directives.AlertBox', dependencies)
        .directive('alertBox', ['sharedConstants', function (sharedConstants) {
            return {
                'restrict': 'E',
                'templateUrl': '/assets/javascripts/shared/directives/alert-box/alert-box.html',
                'controller': ['$rootScope', '$scope', '$timeout', '$sce', function ($rootScope, $scope, $timeout, $sce) {

                    $scope.alertbox = {};

//alert messages for success and failure
                    var alertMessages = sharedConstants.getAlertMessages();

                    var showAlertMessage = function (isSuccess, alertMessage, noTimeout) {
                        $scope.alertbox.message = $sce.trustAsHtml(alertMessage);

                        if (isSuccess === 'success') {
                            $scope.alertType = 'alert-success';
                        } else if (isSuccess === 'info') {
                            $scope.alertType = 'alert-info';
                        } else {
                            $scope.alertType = 'alert-error';
                        }
                        $scope.showAlertBox = true;
                        angular.element('#customSuccessAlert').fadeIn();

                        if (!noTimeout) {
                            $timeout(function () {
                                $scope.showAlertBox = false;
                            }, 7000);
                        }

                        if (!$scope.$$phase) {
                            $scope.$apply();
                        }

                        // Decouple the previous events to prevent multiple execution at the same time & then assign the new click handler
                        // TODO: Need to implement the same with scope variable once time permits.
                        angular.element('#customCloseAlert').off('click').on('click', function () {
                            angular.element('#customSuccessAlert').fadeOut();
                        });

                    };

                    // Display a small success message at the top of the screen
                    $rootScope.$on(alertMessages.SHOW_SUCCESS_MESSAGE, function (event, successMessage) {
                        showAlertMessage('success', successMessage, false);
                    });

                    /*
          * Display a success message at the top of the screen until user clicks the "close(X)" icon
                     * This is an override method to display the message until user clicks on "close" icon.
                     */
                    // TODO: Check if we can combine both the methods after confirming that we need to remove timeout for all
                    $rootScope.$on(alertMessages.SHOW_SUCCESS_MESSAGE_NO_TIMEOUT, function (event, successMessage) {
                        showAlertMessage('success', successMessage, true);
                    });

                    // Display a small error message at the top of the screen
                    $rootScope.$on(alertMessages.SHOW_FAILURE_MESSAGE, function (event, failureMessage) {
                        showAlertMessage('error', failureMessage, false);
                    });

                    /*
                    * Display an error message at the top of the screen until user clicks the "close(X)" icon
                               * This is an override method to display the message until user clicks on "close" icon.
                               */
                    // TODO: Check if we can combine both the methods after confirming that we need to remove timeout for all
                    $rootScope.$on(alertMessages.SHOW_FAILURE_MESSAGE_NO_TIMEOUT, function (event, failureMessage) {
                        showAlertMessage('error', failureMessage, true);
                    });
// Display a small info message at the top of the screen
                    $rootScope.$on(alertMessages.SHOW_INFO_MESSAGE, function (event, infoMessage) {
                        showAlertMessage('info', infoMessage, false);
                    });

                    /*
                    * Display an info message at the top of the screen until user clicks the "close(X)" icon
                               * This is an override method to display the message until user clicks on "close" icon.
                               */
                    // TODO: Check if we can combine both the methods after confirming that we need to remove timeout for all
                    $rootScope.$on(alertMessages.SHOW_INFO_MESSAGE_NO_TIMEOUT, function (event, infoMessage) {
                        showAlertMessage('info', infoMessage, true);
                    });

                }]
            };
        }]);

});

